import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";
import { formQKeys } from "@hooks/queries/forms/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";
import { ServiceFormConfiguration } from "@customTypes/forms";

export const useSaveFormConfig = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (config: ServiceFormConfiguration) => {
      return api.post("form-configurations/create", config);
    },
    onSuccess: (_, variables) => {
      showSuccessNotification({
        title: "success",
        message: "form-configuration-saved-success",
      });

      queryClient.invalidateQueries({
        queryKey: formQKeys.config(variables.service_id),
      });
    },
    onError: (res: any) => {
      console.error("[From Save Form Config]", res);
      handleErrors(res, "mutation");
    },
  });
};
